export default __webpack_public_path__ + "static/media/lock.e7f4b439.svg";